import request from '../untils/request';

const dataManageApi = {
  list: '/api/deviceFileInfo/page', // 列表
  download: '/api/deviceFileInfo/download', // 下载文件
};

export function getList(param) {
  // console.log('dataManageApi---getlist--');
  return request({
    url: dataManageApi.list,
    method: 'get',
    params: param,
    // headers: { 'X-Requested-With': 'XMLHttpRequest' },
  });
}

export function downloadFile(param) {
  // console.log('dataManageApi---getlist--');
  return request({
    url: dataManageApi.download,
    method: 'get',
    params: param,
    responseType: 'blob',
    maxContentLength: 20000,
    // headers: { 'X-Requested-With': 'XMLHttpRequest' },
  });
}
